import { CustomEventList, debugEvent } from '@hotjar/webapp/features/Playbacks/utils/debugEvent';
import type { Store } from '../../../store/player/types';

import { isDebugActive } from './isDebugActive';
import { handleMouseClickEvent } from './handleMouseClickEvent';
import { handleViewportResizeEvent } from './handleViewportResizeEvent';
import { ViewportResizeEvent } from '@hotjar/webapp/features/Playbacks/types';

export const onHandleEvents = (
  store: Store,
  page: number,
  fromPosition: number,
  toPosition: number,
  skipNonMutationEvents: boolean,
): void => {
  const { startPageContentIdentifier, playbackScript, setShowCursor, recording } = store.getState();
  if (!recording) return;

  const eventsForTick = recording.page_visit_recordings[page].events;
  const windowWidth =
    recording.page_visit_recordings[page].window_width ||
    recording.page_visit_recordings.find((page) => page.window_width)?.window_width ||
    0;

  let lastMouseMove;
  let lastMouseClick;
  let lastViewportResize;

  // We only need to process the last of each event time in each batch,
  // so we iterate and store, then process if found.
  for (let i = fromPosition; i <= toPosition; i++) {
    const event = eventsForTick[i];

    if (isDebugActive(store, event.type)) {
      const relatedDomNode = window.frames[0]?.window?._hjRecording?.pageDom?.idMap[event.id];
      debugEvent(event.type, event as unknown as CustomEventList, relatedDomNode);
    }

    switch (event.type) {
      case 'mouse_move':
        lastMouseMove = event;
        break;
      case 'mouse_click':
        lastMouseClick = event;
        break;
      case 'viewport_resize':
        lastViewportResize = event;
        break;
    }
  }

  // Process the last found event of each type.
  if (lastMouseMove) setShowCursor(true);
  if (lastMouseClick) handleMouseClickEvent(store);
  if (lastViewportResize)
    handleViewportResizeEvent(store, lastViewportResize as ViewportResizeEvent);

  playbackScript.sendEventsData(eventsForTick, windowWidth, {
    page,
    recordingId: recording.id,
    startPageContentIdentifier,
    fromPosition: fromPosition,
    toPosition: toPosition,
    skipNonMutationEvents,
  });
};
